export default {
  page_title: 'Suppressions | Thanx',
  title: 'Suppressions',
  subtitle:
    'Users who have been removed from communications in the last 7 days.',
  compliance_notice:
    'These contacts exercised their right to be forgotten. Please make sure to also remove them from all your other systems within 7 days, after which their records will be removed from Thanx. <a href="https://help.thanx.com/hc/en-us/articles/38946440916119-Email-Suppression-List" target="_blank" rel="noopener noreferrer">Learn more about account suppression.</a>',
  empty: 'No suppressions in the last 7 days.',
  columns: {
    identifier: 'Identifier',
    suppressed_at: 'Date',
  },
}
